import React, { useEffect } from "react";

const Testimonials = () => {
  useEffect(() => {
    if (!document.getElementById("poper-js-script")) {
      const s = document.createElement("script");
      s.id = "poper-js-script";
      s.setAttribute("data-account-id", "ec9d8d63a9689f8d32c9bc606758ce71");
      s.setAttribute("data-domain", "rxo.me");
      s.src =
        "https://app.poper.ai/share/poper.js?accountID=ec9d8d63a9689f8d32c9bc606758ce71&v=mpr8hs8x";
      s.defer = true;
      document.body.appendChild(s);
    }

    window.Poper = window.Poper || [];
    window.Poper.push({
      accountID: "ec9d8d63a9689f8d32c9bc606758ce71",
      domain: "rxo.me",
    });
  }, []);

  return (
    <section id="voices" data-testid="testimonials-section" className="relative bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-[1480px] px-6 md:px-12">
        <div className="mb-14 grid grid-cols-12 items-end gap-6 md:mb-20">
          <div className="col-span-12 md:col-span-8">
            <div className="font-mono text-xs uppercase tracking-[0.22em] text-ultra">
              05 — Voices
            </div>

            <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.92] tracking-tightest text-ink md:text-7xl">
              The people we
              <br />
              build <span className="italic text-ultra">alongside.</span>
            </h2>
          </div>

          <div className="col-span-12 flex md:col-span-4 md:justify-end">
            <div className="rounded-sm border border-ink px-5 py-4 font-mono text-[10px] uppercase tracking-[0.2em] text-ink shadow-brutal">
              Backed by Google reviews            
            </div>
          </div>
        </div>

        <div className="poper-11572"></div>
      </div>
    </section>
  );
};

export default Testimonials;